import * as Sentry from "@sentry/browser";

const apiUrl = 'https://api.saleae.com/graphql';


// returns vatState; null on fail
async function verifyVatNumber(vatNumber) {
  const query = {
    query: 'query VerifyVAT ($vat: String!) {lookupVAT(vat: $vat)}',
    variables: {vat: vatNumber},
  };

  let data = await graphQlFetch(query);

  const vatCompany = data.lookupVAT;
  if (vatCompany !== null) {
    const vatState = {
      company: vatCompany,
      number: vatNumber,
    };
    return vatState;
  }
  return null;
}

// returns immediately
function setCustomerInfo(customerId, currency, vatExempt, vatNumber) {
  let queryStr = '';
  let variables = {};

  queryStr =
      'mutation SetTaxExemptStatus ($customerId: String!, $currency: String!, $status: Boolean!, $vat: String!) {setTaxExemptStatus(customerId: $customerId, currency: $currency, status: $status, vat: $vat)}';
  variables = {
    customerId,
    currency,
    status: vatExempt,
    vat: vatNumber,
  };

  /*
  if (vatExempt) {
      queryStr = 'mutation SetTaxExemptStatus ($customerId: String!, $currency:
  String!, $status: Boolean!, $vat: String!) {setTaxExemptStatus(customerId:
  $customerId, currency: $currency, status: $status, vat: $vat)}'; variables = {
          customerId, currency, status: vatExempt, vat: vatNumber,
      };
  } else {
      // don't send $vat (vat number); I'm not sure why we can't just send ''
      queryStr = 'mutation SetTaxExemptStatus ($customerId: String!, $currency:
  String!, $status: Boolean!) {setTaxExemptStatus(customerId: $customerId,
  currency: $currency, status: $status)}'; variables = { customerId, currency,
  status: vatExempt };
  }
  */

  const query = {
    query: queryStr,
    variables,
  };

  graphQlFetch(query);
}

async function getCountryIsoFromIp() {
  const query = {query: 'query {lookupGeoIP}'};
  let data;
  try
  {
    data = await graphQlFetch(query);
  } catch(err)
  {
    Sentry.captureException(err);
    return "US";
  }
  if(data && data.lookupGeoIP && typeof data.lookupGeoIP === 'string') {
    return data.lookupGeoIP;
  }
  console.warn('webapi error');
  return "US";
}

async function graphQlFetch(query) {
  const request = {
    body: JSON.stringify(query),
    method: 'POST',
    mode: 'cors',
    headers: {
      'Content-Type': 'application/json',
    },
  };

  let response = await fetch(apiUrl, request);
  let json = await response.json();
  return json.data;
}

export {
  getCountryIsoFromIp,
  verifyVatNumber,
  setCustomerInfo,
};
